<template>
  <section class="winners-2019-section">
    <div class="container">
      <div class="grid-box">
        <Winners2019Winner />
        <ul class="winners-2019-section__list row">
          <li
            v-for="(info, index) in winners"
            :key="index"
            class="col-12 col-lg-6"
          >
            <Winners2019PlaceWinnersCard
              :winners_1="info.winners_1"
              :winners_2="info.winners_2"
              :img="info.img"
            >
              <template #title>{{ info.title }}</template>
              <template #prize>
                <p v-html="info.text"></p>
              </template>
            </Winners2019PlaceWinnersCard>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import Winners2019Winner from "./Winners2019Winner";
import Winners2019PlaceWinnersCard from "./Winners2019PlaceWinnersCard";

export default {
  name: "Winners2019Section",
  components: {
    Winners2019Winner,
    Winners2019PlaceWinnersCard
  },
  data: () => ({
    winner: {
      id: 699,
      nickname: "Soloma",
      steam_id64: "76561198811489164",
      avatar:
        "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/4a/4a111478f851c1937e95af5af5f56de90ed48571_full.jpg"
    },
    winners: [
      {
        img: require("@/assets/img/prizes/levels-100_small.png"),
        title: "2 место",
        text: `<span class="orange">Набор</span> на <span class="text-big">100 уровней</span> <span class="orange">боевого пропуска</span> или Arcana <span class="orange">до $45</span> <div class="mt-2 font-weight-medium"><span class="orange mt-2">+ 45 000 рублей</span> от Организатора</div>`,
        winners_1: [
          {
            id: 450,
            nickname: "iLOVEOKAYGGWP",
            steam_id64: "76561198051928894",
            avatar:
              "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/30/30ea90a9391415e01d18f32353a1d5b2ff667437_full.jpg"
          }
        ]
      },
      {
        img: require("@/assets/img/prizes/levels-50_small.png"),
        title: "3-4 место",
        text: `<span class="orange">Набор</span> на <span class="text-big">50 уровней</span> <span class="orange">боевого пропуска</span> или Arcana <span class="orange">до $45</span><div class="mt-2 font-weight-medium"><span class="orange mt-2">+ 20 000 рублей</span> от Организатора</div>`,
        winners_1: [
          {
            id: 825,
            nickname: "Ищу Путь Ниндзя",
            steam_id64: "76561198164096930",
            avatar:
              "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/41/41f07e0de4f1583387401c540dc46fdaa3d68eba_full.jpg"
          }
        ],
        winners_2: [
          {
            id: 523,
            nickname: "Ah",
            steam_id64: "76561198048714922",
            avatar:
              "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/cb/cb114d8c0984bd4715a6a1c323be6fe4b25432c0_full.jpg"
          }
        ]
      },
      {
        img: require("@/assets/img/prizes/levels-25_small.png"),
        title: "5-8 место",
        text: `<span class="orange">Боевой пропуск</span> <span class="text-big">24 уровня</span><div class="mt-2 font-weight-medium"><span class="orange mt-2">+ 10 000 рублей</span> от Организатора</div>`,
        winners_1: [
          {
            id: 576,
            nickname: "Arima",
            avatar:
              "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/62/6281f32c1c5eb9dab4270b6c4a5107b0f718ad91_full.jpg",
            country: "KR",
            steam_id64: "76561198075199217"
          },
          {
            id: 351,
            nickname: "БАТУСАЙ СОКРУШИТЕЛЬ",
            avatar:
              "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/cf/cf6b1c7c1e2d8ac786b1ae65fb4471871f924279_full.jpg",
            country: "PL",
            steam_id64: "76561198059485298"
          },
          {
            id: 978,
            nickname: "Ange7",
            avatar:
              "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/5f/5f119622b857230e5ff4ef4287513abaf0fb3c51_full.jpg",
            country: null,
            steam_id64: "76561198963739293"
          },
          {
            id: 1570,
            nickname: "diligently",
            avatar:
              "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/22/2209f4a6a8860fdb62fe85978f71a33ef088d217_full.jpg",
            country: null,
            steam_id64: "76561198133005684"
          }
        ]
      },
      {
        img: require("@/assets/img/prizes/levels-25_small.png"),
        title: "9-16 место",
        text: `<span class="orange">Боевой пропуск</span> <span class="text-big">24 уровня</span><div class="mt-2 font-weight-medium"><span class="orange mt-2">+ Призы</span> от Организатора</div>`,
        winners_1: [
          {
            id: 232,
            nickname: "Admiral_Sapozhnik",
            avatar:
              "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/c6/c66e5c746ffad4b9e44bc58c55583708863bb4bf_full.jpg",
            country: "RU",
            steam_id64: "76561198804702427"
          },
          {
            id: 379,
            nickname: "empire.97 (1997)",
            avatar:
              "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/e6/e6ef8243a2ebcae794ca33c6333f6fd7f53a5ff1_full.jpg",
            country: null,
            steam_id64: "76561198963890092"
          },
          {
            id: 479,
            nickname: "→♣MrDenMan♣←",
            avatar:
              "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/f9/f9a663b4526bed8f49991844cbc3b10eef798d44_full.jpg",
            country: null,
            steam_id64: "76561198110939453"
          },
          {
            id: 670,
            nickname: "prl",
            avatar:
              "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/b5/b5e877432bee0e7f9031eace92a1a82d9ca8782b_full.jpg",
            country: null,
            steam_id64: "76561198033395482"
          }
        ],
        winners_2: [
          {
            id: 251,
            nickname: "KAtala",
            avatar:
              "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/f8/f8f46b29fa8993e68b782565989b93c6fedfc763_full.jpg",
            country: "RU",
            steam_id64: "76561198161942510"
          },
          {
            id: 1913,
            nickname: "Black Jack Davey",
            avatar:
              "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/bd/bddf4f4cdb57bb8090322fccfdad74c5232cea74_full.jpg",
            country: null,
            steam_id64: "76561198027659672"
          },
          {
            id: 2398,
            nickname: "Simper",
            avatar:
              "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/08/087a48aab0d1f27af6c4e0dce8d9a071c2b3ec6f_full.jpg",
            country: "RU",
            steam_id64: "76561198036935837"
          },
          {
            id: 733,
            nickname: "харьковская шпрота",
            avatar:
              "https://steamcdn-a.akamaihd.net/steamcommunity/public/images/avatars/66/66417c22cca24f292b5e7e67447d434e55a0696a_full.jpg",
            country: "NE",
            steam_id64: "76561198172140097"
          }
        ]
      }
    ]
  })
};
</script>

<style lang="scss">
.winners-2019-section {
  margin-bottom: 30px;
  &__list {
    list-style: none;
    background: url("~@/assets/img/prizes/prize-bg.png") center no-repeat;
    > [class*="col-"] {
      padding-top: 25px;
      padding-bottom: 25px;
    }
  }
}
</style>
